export const textStyles: React.CSSProperties = {
  marginTop: '8px',
};
